export const SWAG_CODES_SETTINGS_ALL_SETTINGS_REQUEST = 'SWAG_CODES_SETTINGS_LOAD_SETTINGS_REQUEST';
export const SWAG_CODES_SETTINGS_ALL_SETTINGS_SUCCESS = 'SWAG_CODES_SETTINGS_ALL_SETTINGS_SUCCESS';
export const SWAG_CODES_SETTINGS_ALL_SETTINGS_FAIL = 'SWAG_CODES_SETTINGS_ALL_SETTINGS_FAIL';

export const SWAG_CODES_SETTINGS_BATCHES_UPDATING_START = 'SWAG_CODES_SETTINGS_BATCHES_UPDATING_START';
export const SWAG_CODES_SETTINGS_BATCHES_UPDATING_END = 'SWAG_CODES_SETTINGS_BATCHES_UPDATING_END';
